import { getRefreshToken } from "../app/modules/Auth/_redux/authCrud";
import * as auth from "../app/modules/Auth/_redux/authRedux";
import store from "./store";

const { dispatch } = store;
export default function setupAxios(axios, store) {
    axios.interceptors.request.use(
        (config) => {
            const {
                auth: { authToken },
            } = store.getState();

            if (authToken) {
                config.headers.Authorization = `Bearer ${authToken}`;
            }

            return config;
        },
        (err) => Promise.reject(err)
    );

    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            const originalRequest = error.config;
            const { setRefreshToken, logout } = auth.actions;
            const {
                auth: { refreshToken },
            } = store.getState();
            if(error.response) {
                if (
                    refreshToken &&
                    error.response.status === 401 && error.response.data.message !== "Invalid credentials." &&
                    !originalRequest._retry
                ) {
                    originalRequest._retry = true;
                    
                         getRefreshToken(refreshToken)
                            .then(
                                ({ data: { token, expiresAt, refreshToken } }) => {
                                    dispatch(
                                        setRefreshToken(token, expiresAt, refreshToken)
                                    );
                                    return axios(originalRequest);
                                }
                            )
                            .catch(() => dispatch(logout()));
                    
                }
            }
            return Promise.reject(error);
        }
    );
}